import React from 'react';

export default function LiveIcon(props: React.SVGAttributes<{}>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width="256"
      height="256"
      fill="currentColor"
      stroke="currentColor"
    >
      <g
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
        stroke="currentColor"
        strokeWidth="0"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      >
        <path
          d="M 85.512 52.466 c 1.104 0 2 -0.896 2 -2 s -0.896 -2 -2 -2 H 74.062 V 36.859 h 11.449 c 1.104 0 2 -0.896 2 -2 s -0.896 -2 -2 -2 H 72.062 c -1.104 0 -2 0.896 -2 2 v 31.214 c 0 1.104 0.896 2 2 2 h 13.449 c 1.104 0 2 -0.896 2 -2 s -0.896 -2 -2 -2 H 74.062 V 52.466 H 85.512 z"
          fill="currentColor"
        />
        <path
          d="M 26.36 34.859 v 31.214 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 V 34.859 c 0 -1.104 -0.896 -2 -2 -2 S 26.36 33.754 26.36 34.859 z"
          fill="currentColor"
        />
        <path
          d="M 19.642 65.301 c 0 -1.104 -0.896 -2 -2 -2 H 6.488 V 35.631 c 0 -1.104 -0.896 -2 -2 -2 s -2 0.896 -2 2 v 29.669 c 0 1.104 0.896 2 2 2 h 13.153 C 18.746 67.301 19.642 66.405 19.642 65.301 z"
          fill="currentColor"
        />
        <path
          d="M 59.861 34.188 l -9.228 25.921 l -9.228 -25.921 c -0.37 -1.041 -1.516 -1.583 -2.555 -1.213 c -1.041 0.371 -1.583 1.515 -1.213 2.555 L 48.75 66.744 c 0.283 0.797 1.038 1.329 1.884 1.329 s 1.601 -0.532 1.884 -1.329 L 63.629 35.53 c 0.371 -1.041 -0.173 -2.185 -1.213 -2.555 C 61.375 32.605 60.23 33.147 59.861 34.188 z"
          fill="currentColor"
        />
        <path
          d="M 7.337 26.797 c 1.092 0.144 2.099 -0.629 2.242 -1.724 c 0.755 -5.782 5.722 -10.142 11.553 -10.142 h 47.737 c 5.831 0 10.798 4.36 11.553 10.141 c 0.132 1.007 0.991 1.741 1.98 1.741 c 0.087 0 0.174 -0.005 0.262 -0.017 c 1.096 -0.143 1.867 -1.147 1.725 -2.242 c -1.014 -7.767 -7.686 -13.624 -15.52 -13.624 H 50.1 l 8.055 -7.465 c 0.811 -0.751 0.858 -2.016 0.107 -2.826 c -0.752 -0.811 -2.018 -0.857 -2.826 -0.107 L 45 10.205 L 34.564 0.533 c -0.811 -0.752 -2.075 -0.702 -2.826 0.107 c -0.751 0.81 -0.703 2.075 0.107 2.826 l 8.055 7.465 H 21.131 c -7.833 0 -14.504 5.857 -15.519 13.623 C 5.47 25.651 6.241 26.655 7.337 26.797 z"
          fill="currentColor"
        />
        <path
          d="M 82.663 74.134 c -1.086 -0.145 -2.099 0.629 -2.242 1.725 C 79.666 81.64 74.7 86 68.868 86 H 21.131 C 15.3 86 10.334 81.64 9.579 75.858 c -0.143 -1.096 -1.151 -1.862 -2.242 -1.725 c -1.096 0.144 -1.867 1.147 -1.725 2.242 C 6.627 84.143 13.299 90 21.131 90 h 47.737 c 7.834 0 14.506 -5.857 15.52 -13.624 C 84.53 75.281 83.759 74.277 82.663 74.134 z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
